<template>
  <div id="lateral">
    <h2><img src="../assets/icon_more.png" width="24" height="24" alt="Mais Produtos">Mais procurados</h2>
    <ul class="lista-unidades">
      <li>
        <p><a @click="mudarSelecao('ccd-servicos')">Senha de Revogação</a></p>
        Altere a senha de revogação do certificado digital.
      </li>
      <li>
        <p><a @click="mudarSelecao('ccd-servicos')">Revogar Certificado</a></p>
        Revogue aqui seu certificado digital utilizando a senha de revogação.
      </li>
    </ul>
  </div>

</template>

<script>
import { EventBus } from '../main';

export default {
  data() {
    return {
      menu: EventBus.menu
    }
  },
  methods: {
    mudarSelecao( selecao ) {
      EventBus.$emit('mudarSelecao', selecao);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// MenuDireita.vue?721d9837